import { toast } from "sonner";

export const input = "w-full rounded-xl border border-slate-200 bg-slate-50 px-3.5 py-2.5 text-slate-900 font-medium outline-none focus:border-orange-400 focus:bg-white focus:ring-4 focus:ring-orange-100 transition";
export const btn = "inline-flex items-center justify-center gap-1.5 bg-orange-500 hover:bg-orange-600 text-white rounded-full px-5 py-2.5 font-bold transition-colors text-sm";
export const btnGhost = "inline-flex items-center gap-1.5 text-slate-500 hover:text-slate-900 font-bold text-sm";

export const copyText = (text) => {
  try {
    navigator.clipboard.writeText(text);
    toast.success("Copié ✓");
  } catch {
    toast.error("Impossible de copier");
  }
};
